"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Sparkles, Sprout } from "lucide-react";
import { cn } from "@/lib/revive-landing/utils";

const toolbarBtnBase =
  "inline-flex shrink-0 items-center rounded-lg px-3 py-2 text-sm font-semibold transition-colors";

const toolbarBtnActive =
  "border border-emerald-500/40 bg-emerald-950/40 text-emerald-100 shadow-[0_0_20px_-8px_rgba(52,211,153,0.45)] hover:border-emerald-400/55 hover:bg-emerald-900/50";

const toolbarBtnInactive =
  "border border-zinc-700/80 bg-zinc-900/50 text-zinc-200 hover:border-zinc-600 hover:bg-zinc-800/80";

export function ReviveMarketingToolbar() {
  const pathname = usePathname() ?? "";
  const liveActive = pathname === "/revivals" || pathname.startsWith("/revivals/");
  const createActive = pathname === "/revive/create" || pathname.startsWith("/revive/create/");

  return (
    <div
      className="sticky top-14 z-[90] border-b border-zinc-800/90 bg-gray-950/90 backdrop-blur-md sm:top-16"
      role="navigation"
      aria-label="Revive marketing"
    >
      {/** Match dashboard header chrome: Bots.jsx `py-3 sm:py-3` + ~86px row height */}
      <div className="mx-auto flex min-h-[86px] max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:gap-4 sm:px-6 sm:py-3 lg:px-8">
        <Link
          href="/revive"
          className="inline-flex min-w-0 shrink-0 items-center gap-2 rounded-lg text-zinc-100 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-950"
          aria-label="Revive — go to hub"
          rel="noopener noreferrer"
        >
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-[6px] border border-emerald-500/30 bg-emerald-950/40">
            <Sprout className="h-[18px] w-[18px] text-emerald-400 sm:h-5 sm:w-5" aria-hidden />
          </span>
          <span className="text-pretty text-2xl font-semibold tracking-tight sm:text-3xl">
            Revive Your Token
          </span>
        </Link>

        <div className="flex flex-wrap items-center justify-end gap-2 sm:gap-3">
          <Link
            href="/revivals"
            className={cn(toolbarBtnBase, liveActive ? toolbarBtnActive : toolbarBtnInactive)}
            aria-current={liveActive ? "page" : undefined}
            rel="noopener noreferrer"
          >
            Live
          </Link>
          <Link
            href="/revive/create"
            className={cn(toolbarBtnBase, "gap-1.5", createActive ? toolbarBtnActive : toolbarBtnInactive)}
            aria-current={createActive ? "page" : undefined}
            rel="noopener noreferrer"
          >
            <Sparkles
              className={cn("h-4 w-4 shrink-0", createActive ? "text-emerald-300" : "text-zinc-400")}
              aria-hidden
            />
            Create revive
          </Link>
        </div>
      </div>
    </div>
  );
}
